import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { firstArray, isFunction } from '@util/utils';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html'
})
export class NotificationComponent implements OnInit {

  btnClass = 'snack-success-btn';

  hasAction = true;

  action = 'OK';

  errors: any[] = [];

  messages: any[] = [];

  constructor(
    public ref: MatSnackBarRef<NotificationComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any) {

    if (data.type === 'error') {
      this.btnClass = 'snack-error-btn';
    }

    this.messages = firstArray(data.messages, this.messages);
    this.errors = firstArray(data.errors, this.errors);
  }

  ngOnInit(): void {
  }

  answer(value:any) {
    if(isFunction(this.data.action)) {
      this.data.action(value, ()=> {
        this.dismiss();
      });
    } else {
      this.dismiss();
    }
  }

  dismiss() {
    this.ref && this.ref.dismiss();
  }
}
